import { IChatMsgAPI } from "../Interfaces";
import { ExplorerAPI } from "./ExplorerAPI";


export class MsgForm {
    constructor(chatId: string) {
        const chatMsg: IChatMsgAPI = {
            chatId: chatId,
            userId: "---",
            userName: "Bot-Form",
            userPhoto: "./assets/icons/bot.svg",
            fragment: true,
            messageType: "MessageNotify",
            time: Date.now(),
            child: {
                componentName: "Form",
                props: {
                    type: "Form",
                    messageType: "MessageNotify",
                }
            }
        }
        new ExplorerAPI.MsgForm(chatMsg);
    }
}